import {
    SET_VIEW, SET_SEARCHTYPE, SET_STATSNAME, SET_FILTERS, SET_TILE_PAGINATION, SET_GRID_PAGINATION, SET_LIST_PAGINATION, SET_LOADMAPVIEW, SET_MAPMETADATA, SET_LOADPFCHARTVIEW, SET_APPLYCLICK
} from './types';
 
const setSelectedView = (selectedView:any) => ({
    type: SET_VIEW,
    selectedView
})
const setSearchType = (searchType: any) => ({
    type: SET_SEARCHTYPE,
    searchType
})
const setStatsName = (statsName: any) => ({
    type: SET_STATSNAME,
    statsName
})
const setFilters = (filters: any) => ({
    type: SET_FILTERS,
    filters
})
const setTilePagination = (tilePagination: any) => ({
    type: SET_TILE_PAGINATION,
    tilePagination
})
const setGridPagination = (gridPagination: any) => ({
    type: SET_GRID_PAGINATION,
    gridPagination
})

const setListPagination = (listPagination: any) => ({
    type: SET_LIST_PAGINATION,
    listPagination
})

const setLoadMapView = (loadmapview: any) => ({
    type: SET_LOADMAPVIEW,
    loadmapview
})
const setMapMetaData = (mapMetaData: any) => ({
    type: SET_MAPMETADATA,
    mapMetaData
})
const setLoadPerfChartView = (loadperfchartview: any) => ({
    type: SET_LOADPFCHARTVIEW,
    loadperfchartview
})
const setApplyClick = (applyClick: any) => ({
    type: SET_APPLYCLICK,
    applyClick
})



export {
    setSelectedView,
    setSearchType,
    setStatsName,
    setFilters,
    setTilePagination,
    setGridPagination,
    setListPagination,
    setLoadMapView,
    setMapMetaData,
    setLoadPerfChartView,
    setApplyClick
};
  